import { assessmentRequest, request, requestrbac } from "../request";

function getCustomerDetails(data) {
  return request({
    url: "cus/customer-details/",
    method: "POST",
    data,
  });
}

function getJobList(data) {
  return request({
    url: "jd/get-jobs/",
    method: "POST",
    data,
  });
}

function selectFolder(data) {
  return requestrbac({
    url: "select-users/",
    method: "get",
    params: { ...data },
  });
}

function usersForList(data) {
  return requestrbac({
    url: "permissionDetials/",
    method: "get",
    params: { ...data },
  });
}
function createJob(data) {
  return request({
    url: "jd/add_job/",
    method: "post",
    data,
  });
}

function updateJob(data) {
  return request({
    url: "jd/add_job/",
    method: "put",
    data,
  });
}

function getJobByID(data) {
  return request({
    url: "jd/get-jobs/",
    method: "post",
    data,
  });
}

function getPanelIDs() {
  return request({
    url: "pan/panel-list/",
    method: "get",
  });
}

function checkTestAutocorrected(data) {
  return assessmentRequest({
    url: "/v2/testAutoCorrectCheck",
    method: "post",
    data,
  });
}

export {
  getCustomerDetails,
  getJobList,
  selectFolder,
  usersForList,
  createJob,
  getJobByID,
  getPanelIDs,
  updateJob,
  checkTestAutocorrected,
};
